import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { OperativoPotencialRoutingModule } from './operativo-potencial-routing.module';
import { MatrizEventosComponent } from './matriz-eventos/matriz-eventos.component';
import { AnalisisEventosComponent } from './analisis-eventos/analisis-eventos.component';
import { AnalaisisCombinadoComponent } from './analaisis-combinado/analaisis-combinado.component';
import { MapaCalorComponent } from './mapa-calor/mapa-calor.component';


@NgModule({
  declarations: [
    MatrizEventosComponent,
    AnalisisEventosComponent,
    AnalaisisCombinadoComponent,
    MapaCalorComponent
  ],
  imports: [
    CommonModule,
    OperativoPotencialRoutingModule,
    SharedModule,
  ]
})
export class OperativoPotencialModule { }
